export default {
    preview: 'button_preview',
    gameday: 'button_gameday',
    tickets: 'button_tickets',
    details: 'button_details',
    audio: 'button_audio',
    watchArchive: 'button_watch_archive',
    watchLive: 'button_watch_live',
    youTube: 'button_youtube',
    box: 'button_box',
    wrap: 'button_wrap',
    final: 'game_status_final',
    free: 'freegameoftheday',
    mlbtvfree: 'mlbtvfreegameoftheday',
    probablePitchers: 'scores_probable_pitchers',
    atBat: 'at_bat',
    Top: 'game_status_top',
    Bottom: 'game_status_bottom_abbrev',
    p: 'pitches_abbrev',
    ip: 'innings_pitched_abbrev',
    ops: 'on_base_plus_slugging_abbrev',
    delayed: 'game_status_delayed',
    suspended: 'game_status_suspended',
    live: 'player_live',
    springTraining: 'game_type_spring_training',
    exhibition: 'game_type_exhibition',
    'AL Wild Card': 'wild_card_al',
    'NL Wild Card': 'wild_card_nl',
    NLDS: 'postseason_nlds',
    ALDS: 'postseason_alds',
    NLCS: 'postseason_nlcs',
    ALCS: 'postseason_alcs',
    NLWC: 'wild_card_nl',
    WS: 'postseason_world_series',
    'World Series': 'postseason_world_series',
    'NL Tiebreaker': 'postseason_tiebreaker_nl',
    'AL Tiebreaker': 'postseason_tiebreaker_al',
    allStar: 'allstar_game',
    instantReplay: 'game_status_instant_replay',
    managerChallenge: 'game_status_manager_challenge',
    umpireReview: 'game_status_umpire_review',
    emptyCollection: 'schedule_message_nogames',
    Middle: 'game_status_mid_short',
    End: 'game_status_end',
    splitSquad: 'split_squad_abbrev',
    liveYouTube: 'live_on_youtube_watch_free',
    allTimes: 'all_times',
    ET: 'time_zone_eastern_short',
    CT: 'time_zone_central_short',
    MT: 'time_zone_mountain_short',
    RT: 'time_zone_mountain_short',
    PT: 'time_zone_pacific_short',
    subjectToChange: 'subject_to_change',
    somethingWentWrong: 'error_something_wrong',
    tryReloading: 'error_try_reloading',
    contactUs: 'contact_us',
    W: 'win_abbrev',
    L: 'loss_abbrev',
    SV: 'save_abbrev',
    'Multiple issues': 'game_status_reason_multiple_issues',
    'Record keeping': 'game_status_reason_record_keeping',
    'Passing runners': 'game_status_reason_passing_runners',
    'Touching a base': 'game_status_reason_touching_a_base',
    'Timing play': 'game_status_reason_timing_play',
    'Hit by pitch': 'game_status_reason_hit_by_pitch',
    'Trap play in outfield': 'game_status_reason_trap_play_in_outfield',
    'Fair/foul in outfield': 'game_status_reason_fair_foul_in_outfield',
    'Tag play': 'game_status_reason_tag_play',
    'Force play': 'game_status_reason_force_play',
    'Stadium boundary call': 'game_status_reason_stadium_boundary_call',
    'Fan interference': 'game_status_reason_fan_interference',
    'Grounds rule': 'game_status_reason_grounds_rule',
    'Home run': 'game_status_reason_home_run',
    'Appeal Upheld': 'game_status_reason_appeal_upheld',
    'Inclement Weather': 'game_status_reason_inclement_weather',
    'Slide interference': 'game_status_reason_slide_interference',
    'About to Resume': 'game_status_reason_about_to_resume',
    'Tragedy': 'game_status_reason_tragedy',
    'COVID-19': 'game_status_reason_covid19',
    'Lightning': 'game_status_reason_lightning',
    'Ceremony': 'game_status_reason_ceremony',
    'Power': 'game_status_reason_power',
    'Wind': 'game_status_reason_wind',
    'Darkness': 'game_status_reason_darkness',
    'Cold': 'game_status_reason_cold',
    'Fog': 'game_status_reason_fog',
    'Venue': 'game_status_reason_venue',
    'Wet Grounds': 'game_status_reason_wet_grounds',
    'Snow': 'game_status_reason_snow',
    'Rain': 'game_status_reason_rain',
    'Instant Replay': 'game_status_reason_instant_replay',
    'Catch/drop in outfield': 'game_status_reason_catch_drop_in_outfield',
    'Close play at 1st': 'game_status_reason_close_play_at_1st',
    'Home-plate collision': 'game_status_reason_homeplate_collision',
    'Mercy Rule': 'game_status_reason_mercy_rule',
    'Rules check': 'game_status_reason_rules_check',
    'Tag-up play': 'game_status_reason_tag_up',
    'Tie, decision by tiebreaker': 'game_status_reason_tiebreaker'
};
